import { createSlice } from "@reduxjs/toolkit";
import { clearMessages, closeSourceDetail, fetchAnswer, fetchAnswerStreaming, fetchSuggestQuestion, openSourceDetail, setMessages, setSourceContent, updateCurrentRepliedMessage } from "./EngageGPTAction";

export interface MessageType {
  message: string;
  owner: "user" | "bot";
  sources: Array<any>;
  processingTime: number;
}
export interface SourceType {
  file_path: string;
  file_name: string;
  page_number: number;
  page_text: string;
  confidence_score: number;
  uuid: string;
  index: number;
  entities: Array<any>;
  next_section_summary: string;
  prev_section_summary: string;
  section_summary: string;
  keywords: Array<any>;
}
interface ChatAIMainStateType {
  loading: boolean;
  initialLoading: boolean;
  error: any;
  messages: Array<MessageType>;
  sourceDetailOpenState: boolean;
  sourceContent: any;
  suggestedQuestions: Array<any>;
}
interface EngageGPTStateType {
  loading: boolean;
  error: any;
  data: any;
  chatAIMainState: ChatAIMainStateType;
}
const engageGPTInitialState: EngageGPTStateType = {
  loading: false,
  error: null,
  data: null,

  chatAIMainState: {
    messages: [],
    loading: false,
    initialLoading: false,
    error: null,
    sourceDetailOpenState: false,
    sourceContent: {
      file_path: "",
      file_name: "",
      page_number: 0,
      page_text: "",
      confidence_score: 0,
      uuid: "",
      index: 0,
      entities: [],
      next_section_summary: "",
      prev_section_summary: "",
      section_summary: "",
      keywords: [],
    },
    suggestedQuestions: [],
  },
};

const engageGPTSlice = createSlice({
  initialState: engageGPTInitialState,
  name: "engageGPT",
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase("engageGPT", (state, action) => {
        console.log("engageGPT action", action);
      })
      .addCase(fetchAnswer.pending, (state, action) => {
        state.chatAIMainState.loading = true;
      })
      .addCase(fetchAnswer.fulfilled, (state, action) => {
        state.chatAIMainState.loading = false;
      })
      .addCase(fetchAnswer.rejected, (state, action) => {
        state.chatAIMainState.loading = false;
        state.chatAIMainState.error = action.error;
      })
      .addCase(fetchAnswerStreaming.pending, (state, action) => {
        state.chatAIMainState.loading = true;
      })
      .addCase(fetchAnswerStreaming.fulfilled, (state, action) => {
        state.chatAIMainState.loading = false;
      })
      .addCase(fetchAnswerStreaming.rejected, (state, action) => {
        state.chatAIMainState.loading = false;
        state.chatAIMainState.error = action.error;
      })
      .addCase(setMessages, (state, action) => {
        console.log("setMessages action", action);
        state.chatAIMainState.messages = [...state.chatAIMainState.messages, action.payload];
      })
      .addCase(clearMessages, (state, action) => {
        state.chatAIMainState.messages = [];
      })

      .addCase(updateCurrentRepliedMessage, (state, action) => {
        if (action.payload.messageType === "answer") {
          state.chatAIMainState.messages = state.chatAIMainState.messages.map((message, index) => {
            if (index === state.chatAIMainState.messages.length - 1) {
              return { ...message, message: `${message.message}${action.payload.message}` };
            }
            return message;
          });
        } else if (action.payload.messageType === "end") {
          console.log(action.payload.message);
          state.chatAIMainState.messages = state.chatAIMainState.messages.map((message, index) => {
            if (index === state.chatAIMainState.messages.length - 1) {
              return { ...message, message: action.payload.message.answer, sources: action.payload.message.filtered_sources, processingTime: action.payload.processingTime };
            }
            return message;
          });
        }
      })
      .addCase(setSourceContent, (state, action) => {
        state.chatAIMainState.sourceContent = action.payload;
      })

      .addCase(openSourceDetail, (state, action) => {
        state.chatAIMainState.sourceDetailOpenState = true;
      })
      .addCase(closeSourceDetail, (state, action) => {
        state.chatAIMainState.sourceDetailOpenState = false;
      })
      .addCase(fetchSuggestQuestion.pending, (state, action) => {
        state.chatAIMainState.initialLoading = true;
      })
      .addCase(fetchSuggestQuestion.fulfilled, (state, action) => {
        state.chatAIMainState.suggestedQuestions = action.payload.suggested_questions;
        state.chatAIMainState.initialLoading = false;
      })
      .addCase(fetchSuggestQuestion.rejected, (state, action) => {
        state.chatAIMainState.initialLoading = false;
        state.chatAIMainState.error = action.error;
      });
  },
});

export default engageGPTSlice.reducer;
